<h2 matDialogTitle>{{ vm.title() }}</h2>
<section matDialogContent>
  <ng-container *ngIf="vm.activated(); else notActivated">
    <p>
      Estás a punto de activar el modo online. Una vez activado este modo, se sincronizarán los
      datos que hayas generado anteriormente en el modo offline y volverás a estar conectado. El
      volumen de datos a sincronizar es:
    </p>
    <ul *ngIf="vm.pendingToSyncCount() as pendingItems">
      <li *ngFor="let item of pendingItems">
        {{ item.text }}: <strong>{{ item.count }}</strong>
      </li>
    </ul>
    <app-message type="info">
      Ten en cuenta que este proceso puede demorarse si hay muchos datos generados en modo offline o
      la conexión no es buena
    </app-message>
    <app-message type="error" *ngIf="vm.syncWithServerError() as error">
      Ha ocurrido un error sincronizando los datos locales con el servidor. Razón:
      <strong>{{ error }}</strong>
    </app-message>
  </ng-container>

  <ng-template #notActivated>
    <p>
      Estás a punto de activar el <strong>modo offline</strong>. Una vez activado este modo, se
      recuperarán los datos necesarios para funcionar sin conexión. Con el modo offline podrás:
    </p>
    <ul>
      <li>Ejecutar órdenes</li>
      <li>Guardar borradores de órdenes</li>
      <li>Duplicar órdenes</li>
    </ul>
    <app-message type="info">
      Recuerda habilitar el <strong>modo online</strong> para sincronizar los datos generados en
      modo offline cuando hayas acabado.
    </app-message>
    <app-message type="error" *ngIf="vm.storeLocalDataError() as error">
      Ha ocurrido un error intentando obtener los datos necesarios desde el servidor. Razón:
      <strong>{{ error }}</strong>
    </app-message>
  </ng-template>
</section>
<footer matDialogActions class="actions">
  <button mat-raised-button color="accent" (click)="close()" [disabled]="vm.loading()">
    <mat-icon>cancel</mat-icon>
    <span>No, cancelar</span>
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="vm.loading()">
    <mat-icon>check_circle</mat-icon>
    <span>Sí, habilitar</span>
  </button>
</footer>
